var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNh24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1447_8375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8974 2.11963L12 4.07974L8.10254 2.11963L12 9.52704L15.8974 2.11963Z",
    fill: "#FFB71B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.288 7.81946L20.0687 6.65705V2.73682L15.2368 4.8109L12.5473 9.87073C13.5819 9.99001 14.5318 10.5005 15.2022 11.2975C15.8726 12.0946 16.2128 13.1179 16.1531 14.1577C16.0934 15.1975 15.6382 16.1751 14.8809 16.8901C14.1236 17.6051 13.1216 18.0035 12.0801 18.0035C11.0385 18.0035 10.0365 17.6051 9.27919 16.8901C8.5219 16.1751 8.06675 15.1975 8.00701 14.1577C7.94728 13.1179 8.28743 12.0946 8.95784 11.2975C9.62826 10.5005 10.5781 9.99001 11.6128 9.87073L8.92334 4.8109L4.11426 2.73682V6.65705L6.94045 7.81946C5.71472 8.89087 4.84507 10.3107 4.44757 11.8894C4.05007 13.4682 4.14363 15.1305 4.71585 16.6546C5.28806 18.1788 6.31165 19.492 7.64992 20.4191C8.98818 21.3461 10.5774 21.8428 12.2054 21.8428C13.8334 21.8428 15.4226 21.3461 16.7609 20.4191C18.0991 19.492 19.1227 18.1788 19.695 16.6546C20.2672 15.1305 20.3608 13.4682 19.9633 11.8894C19.5658 10.3107 18.6961 8.89087 17.4704 7.81946H17.288Z",
    fill: "#FFB71B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1447_8375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19.7607,
    fill: "white",
    transform: "translate(4 2.11963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh24);
export default __webpack_public_path__ + "static/media/NH농협-24.e73db8fdd179665ffb8b9146546c4d48.svg";
export { ForwardRef as ReactComponent };